import React, { useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import StatWrapper from '../../components/match/layout/StatWrapper';
import OddsWrapper from '../../components/match/layout/OddsWrapper';
import LineUpWrapper from '../../components/match/layout/LineUpWrapper';
import BroadCastWrapper from '../../components/match/layout/BroadCastWrapper';
import RecordWrapper from '../../components/match/layout/RecordWrapper';
import ScoreDetailStore from '../../store/score/ScoreDetailStore';
import ScoreMatchLayout from '../../components/match';
import Analysis from '../../components/match/layout/Analysis';

const SportMatch = (props) => {
  const { sportsType, id, type } = props.match.params;
  const { getScoreDetail, data } = ScoreDetailStore();

  useEffect(() => {
    getScoreDetail(sportsType, id);
  }, []);

  return (
    <ScoreMatchLayout sportsType={sportsType} gameData={data} selectType={type}>
      <Switch>
        <Route
          exact
          path="/match/:sportsType/:id/stat"
          render={() => <StatWrapper sportsType={sportsType} gameData={data} />}
        />
        <Route
          exact
          path="/match/:sportsType/:id/analysis"
          render={() => <Analysis gameId={id} sportsType={sportsType} />}
        />
        <Route
          exact
          path="/match/:sportsType/:id/odds"
          render={() => <OddsWrapper sportsType={sportsType} gameData={data} />}
        />
        <Route
          exact
          path="/match/:sportsType/:id/lineup"
          render={() => <LineUpWrapper sportsType={sportsType} />}
        />
        <Route
          exact
          path="/match/:sportsType/:id/broadcast"
          render={() => (
            <BroadCastWrapper sportsType={sportsType} gameData={data} />
          )}
        />
        <Route
          exact
          path="/match/:sportsType/:id/record"
          render={() => (
            <RecordWrapper sportsType={sportsType} gameData={data} />
          )}
        />
      </Switch>
    </ScoreMatchLayout>
  );
};

export default SportMatch;
